<template>
  <input
    ref="inputRef" type="text"
    @focus="$emit('focus');enabled = true"
    @blur="$emit('blur')"
  />
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import { NumberInput } from 'intl-number-input';

export default {
  name: 'CurrencyInput',
  props: {
    value: [Number, String],
    options: Object,
  },
  emits: ['focus', 'blur', 'update:value'],
  setup(props, { emit, attrs }) {
    let numberInput;
    const inputRef = ref(null);
    const enabled = ref(null);
    const lazyModel = attrs.modelModifiers?.lazy;
    onMounted(() => {
      if (inputRef.value) {
        numberInput = new NumberInput({
          el: inputRef.value,
          options: props.options,
          onInput: (value) => {
            if (!lazyModel && enabled.value) {
              emit('update:value', `${props.options.formatStyle === 'percent' ? Number(value.number || 0) * 100 : Number(value.number || 0)}`);
            }
          },
          onChange: (value) => {
            if (lazyModel && enabled.value) {
              emit('update:value', `${props.options.formatStyle === 'percent' ? Number(value.number || 0) * 100 : Number(value.number || 0)}`);
            }
          },
        });
        numberInput.setValue(
          Number(
            props.options.formatStyle === 'percent'
              ? Number(props.value || 0) / 100
              : Number(props.value || 0),
          ),
        );
      }
    });
    watch(
      () => props.options,
      (options) => {
        numberInput.setOptions(options);
      },
    );

    watch(
      () => props.value,
      (value) => {
        numberInput.setValue(Number(props.options.formatStyle === 'percent' ? (value || 0) / 100 : value || 0));
      },
    );

    return {
      inputRef,
      enabled,
    };
  },
  methods: {
    focus() {
      this.$refs.inputRef.focus();
    },
  },
};
</script>
